import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";

// Rendered by the app-level Sentry.ErrorBoundary when a render error would
// otherwise blank the whole app. Keeps the user on a themed page with a way
// to recover (a full reload is the safest reset after an unhandled crash).
export default function ErrorFallback() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 480, textAlign: "center" }}>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <ErrorOutlinedIcon color="error" sx={{ fontSize: 48 }} />
          <Typography variant="h6">Something went wrong</Typography>
          <Typography sx={{ color: "text.secondary" }}>
            An unexpected error occurred. Please reload the page to continue.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Reload page
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
